import { GET_PRODUCT_CATEGORIES } from "../../type/productCategories";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const productCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_CATEGORIES:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default productCategoryReducer;
